import Actions from "./Actions";
import React from "react";
import StatusBadge from "@/components/StatusBadge";

export const columns = (handleOnClickDelete) => {
  return [
    {
      accessorKey: "actions",
      header: "Actions",
      enableResizing: false,
      enableSorting: false,
      cell: ({ row }) => (
        <Actions row={row} handleOnClickDelete={handleOnClickDelete} />
      ),
    },
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ row }) => <div>{row.getValue("name")}</div>,
    },
    {
      accessorKey: "permission_names",
      header: "Permissions",
      cell: ({ row }) => (
        <div>
          {/* {row.getValue("permission_names").map((name) => (
            <span className="mr-2">{name}</span>
          ))} */}
        </div>
      ),
    },
  ];
};
